import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=46d09637&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=ts"
export * from "./Templates.vue?vue&type=script&lang=ts"
import style0 from "./Templates.vue?vue&type=style&index=0&id=46d09637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d09637",
  null
  
)

export default component.exports